import "core-js/modules/es6.reflect.construct.js";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

/**
* This source code is quoted from rc-tabs.
* homepage: https://github.com/react-component/tabs
*/
import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { setTransform, isTransformSupported, getLeft, getStyle, getTop, getActiveIndex, requestAnimationFrame } from './utils';

function _componentDidUpdate(component, init) {
  var _component$props = component.props,
      styles = _component$props.styles,
      panels = _component$props.panels,
      activeKey = _component$props.activeKey,
      direction = _component$props.direction,
      tabBarStyle = _component$props.tabBarStyle;
  var rootNode = component.props.getRef('root');
  var wrapNode = component.props.getRef('nav') || rootNode;
  var inkBarNode = component.props.getRef('inkBar');
  var activeTab = component.props.getRef('activeTab');
  var inkBarNodeStyle = inkBarNode.style;
  var tabBarPosition = component.props.tabBarPosition;
  var activeIndex = getActiveIndex(panels, activeKey);

  if (init) {
    // prevent mount animation
    inkBarNodeStyle.display = 'none';
  }

  if (activeTab) {
    var tabNode = activeTab;
    var transformSupported = isTransformSupported(inkBarNodeStyle); // Reset current style

    setTransform(inkBarNodeStyle, '');
    inkBarNodeStyle.width = '';
    inkBarNodeStyle.height = '';
    inkBarNodeStyle.left = '';
    inkBarNodeStyle.top = '';
    inkBarNodeStyle.bottom = '';
    inkBarNodeStyle.right = '';

    if (tabBarPosition === 'top' || tabBarPosition === 'bottom') {
      var isFirstTab = tabNode.previousSibling === null;
      var isSimpleTabs = tabBarStyle === 'simple';
      var isTrangleTabs = tabBarStyle === 'trangle';
      var tabBarNodeWidth = isTrangleTabs ? 12 : 16;
      var left = getLeft(tabNode, wrapNode);
      var width = tabNode.offsetWidth;
      var leftOffset = parseInt(width - tabBarNodeWidth) / 2; // simple类型tabs加padding-left，偏移量正常
      // let leftOffset = (isFirstTab && isSimpleTabs) ? 0 : parseInt(width - tabBarNodeWidth) / 2 // simple类型的tabs的第一个tab没有padding-left，偏移量也是0
      // If tabNode'width width equal to wrapNode'width when tabBarPosition is top or bottom
      // It means no css working, then ink bar should not have width until css is loaded
      // Fix https://github.com/ant-design/ant-design/issues/7564

      if (width === rootNode.offsetWidth) {
        width = 0;
      } else if (styles.inkBar && styles.inkBar.width !== undefined) {
        width = parseFloat(styles.inkBar.width, 10);

        if (width) {
          left += (tabNode.offsetWidth - width) / 2;
        }
      }

      if (direction === 'rtl') {
        left = getStyle(tabNode, 'margin-left') - left;
      } // if (isFirstTab && isSimpleTabs) {
      //   left = (width - getStyle(tabNode, 'padding-right') - tabBarNodeWidth) / 2
      // }
      // use 3d gpu to optimize render


      if (transformSupported) {
        setTransform(inkBarNodeStyle, "translate3d(".concat(left + leftOffset, "px,0,0)"));
      } else {
        inkBarNodeStyle.left = "".concat(left + leftOffset, "px");
      }
    } else {
      var top = getTop(tabNode, wrapNode, true);
      var height = tabNode.offsetHeight;

      if (styles.inkBar && styles.inkBar.height !== undefined) {
        height = parseFloat(styles.inkBar.height, 10);

        if (height) {
          top += (tabNode.offsetHeight - height) / 2;
        }
      }

      if (transformSupported) {
        setTransform(inkBarNodeStyle, "translate3d(0,".concat(top, "px,0)"));
        inkBarNodeStyle.top = '0';
      } else {
        inkBarNodeStyle.top = "".concat(top, "px");
      }

      inkBarNodeStyle.height = "".concat(height, "px");
    }
  }

  inkBarNodeStyle.display = activeIndex !== -1 ? 'block' : 'none';
}

var InkTabBarNode = /*#__PURE__*/function (_React$Component) {
  _inherits(InkTabBarNode, _React$Component);

  var _super = _createSuper(InkTabBarNode);

  function InkTabBarNode() {
    _classCallCheck(this, InkTabBarNode);

    return _super.apply(this, arguments);
  }

  _createClass(InkTabBarNode, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this = this;

      this.timeout = setTimeout(function () {
        _componentDidUpdate(_this, true);
      }, 0);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      var _this2 = this;

      requestAnimationFrame(function () {
        return _componentDidUpdate(_this2);
      });
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      clearTimeout(this.timeout);
    }
  }, {
    key: "render",
    value: function render() {
      var _classnames;

      var _this$props = this.props,
          clsPrefix = _this$props.clsPrefix,
          styles = _this$props.styles,
          inkBarAnimated = _this$props.inkBarAnimated;
      var className = "".concat(clsPrefix, "-ink-bar");
      var classes = classnames((_classnames = {}, _defineProperty(_classnames, className, true), _defineProperty(_classnames, inkBarAnimated ? "".concat(className, "-animated") : "".concat(className, "-no-animated"), true), _classnames));
      return /*#__PURE__*/React.createElement("div", {
        style: styles.inkBar,
        className: classes,
        key: "inkBar",
        ref: this.props.saveRef('inkBar')
      });
    }
  }]);

  return InkTabBarNode;
}(React.Component);

export { InkTabBarNode as default };
InkTabBarNode.propTypes = {
  clsPrefix: PropTypes.string,
  styles: PropTypes.object,
  inkBarAnimated: PropTypes.bool,
  saveRef: PropTypes.func,
  direction: PropTypes.string
};
InkTabBarNode.defaultProps = {
  clsPrefix: '',
  inkBarAnimated: true,
  styles: {},
  saveRef: function saveRef() {}
};


// WEBPACK FOOTER //
// ./~/@tinper/next-ui/lib/wui-tabs/src/InkTabBarNode.js